module.exports = __webpack_public_path__ + "static/img/sec2-content03-img06@t.32ddda9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ybTour/sec2-content03-img06@t.jpg
// module id = WGIl
// module chunks = 0